import { paymasterDataSchema, } from '../types';
import { CodeException, errorCategories, errorToCodeException, } from '../../../../errors';
import { getPaymasterModifiedGas } from './getPaymasterModifiedGas';
export async function payGasWithUSDC(args) {
    const { rpcRequestWithUSDCApproval, accessToken, paymasterProxyAuthSecret, paymasterProxyUrl, enableUsdc, } = args;
    if (!enableUsdc) {
        return;
    }
    if (!rpcRequestWithUSDCApproval.callData) {
        throw new CodeException({
            message: 'rpcRequest.callData is required',
            code: 'USER_OPS_PAY_GAS_WITH_USDC_CALL_DATA_REQUIRED',
            category: 'userop',
        });
    }
    const usdcPaymasterData = await getUSDCPaymasterData({
        rpcRequest: rpcRequestWithUSDCApproval,
        paymasterProxyAuthSecret,
        accessToken,
        paymasterProxyUrl,
    });
    const gas = getPaymasterModifiedGas({ paymasterData: usdcPaymasterData });
    // if it's not a 0.7 response, reject (for now this is for modular accounts only)
    // we can add 0.6 support later if we need to
    if (!gas.paymasterVerificationGasLimit || !gas.paymasterPostOpGasLimit) {
        throw new CodeException({
            message: 'Pay gas with USDC is only supported for 0.7 entrypoints',
            code: 'USER_OPS_PAY_GAS_WITH_USDC_NOT_SUPPORTED',
            category: 'userop',
        });
    }
    return {
        gas,
        callData: rpcRequestWithUSDCApproval.callData,
    };
}
async function getUSDCPaymasterData(args) {
    const { rpcRequest, paymasterProxyAuthSecret, accessToken, paymasterProxyUrl } = args;
    if (!paymasterProxyUrl) {
        throw new CodeException({
            message: '[getUSDCPaymasterData] paymasterProxyUrl is required',
            code: 'USER_OPS_PAY_GAS_WITH_USDC_PAYMASTER_PROXY_URL_REQUIRED',
            category: 'userop',
        });
    }
    const sponsorUserOpUrl = `${paymasterProxyUrl}/api/pay-gas-with-usdc`;
    const response = await fetch(sponsorUserOpUrl, {
        method: 'POST',
        body: JSON.stringify({
            data: rpcRequest,
        }),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${paymasterProxyAuthSecret}`,
            'X-PM-Token': accessToken ?? '',
        },
    });
    const json = await response.json();
    if (!response.ok) {
        const error = new Error(`[getUSDCPaymasterData] Error getting paymaster proxy response:: ${response.status} ${response.statusText} ${JSON.stringify(json)}`);
        const errorCategory = errorCategories.userop_pm_error_code;
        throw errorToCodeException(error, errorCategory);
    }
    const parseResult = paymasterDataSchema.safeParse(json);
    if (!parseResult.success) {
        const error = new Error(`[getUSDCPaymasterData] Error parsing PaymasterProxyResponse:: ${JSON.stringify(parseResult.error)}`);
        const errorCategory = errorCategories.userop_pm_error_code;
        throw errorToCodeException(error, errorCategory);
    }
    const parsedData = parseResult.data.data;
    return parsedData;
}
